import { render, staticRenderFns } from "./provinces.vue?vue&type=template&id=1b275b05"
import script from "./provinces.vue?vue&type=script&lang=js"
export * from "./provinces.vue?vue&type=script&lang=js"
import style0 from "./provinces.vue?vue&type=style&index=0&id=1b275b05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports